export const DEMO_PRODUCTS_MULTI = [
  {
    SewingModelId: "0099",
    FabricId: "71008370",
    FabricDesignFa: "امری",
    FabricDesignEn: "Emery",
    FabricColorEn: "Linen",
    FabricColorFa: "لینن",
    PhotoUrl: "Content/Images/Product/2022/2022-05-09/71008370/71008370_0099.jpg?v=51550",
    FabricId2: "90906903",
    FabricDesignFa2: "تورلینن",
    FabricDesignEn2: "Linen M Sheer",
    FabricColorEn2: "White",
    FabricColorFa2: "سفید",
    PhotoUrl2: "Content/Images/Product/2023/2023-12-26/90906903/90906903_0099.jpg?v=51551",
    SheerHeaderStyle: "Inverted Box Pleat",
    SheerHeaderStyleID: "0036",
    PrivacyLayer: "Semi Sheer",
    SheersId1: "9990909002",
    SheersDesignFa: "سرن",
    SheersDesignEn: "Serene",
    SheersColorEn: "Ice",
    SheersColorFa: "یخی",
    SheersPhotoUrl: "Content/Images/Product/2021/2021-10-20/9990909002/9990909002_0099.jpg?v=45206",
    PrivacyLayerHeaderStyle: "Pencil Pleat",
    PrivacyLayerHeaderStyleID: "0002",
    MountPositionId: 4802,
    CalcWindowSize: false,
    FinishedLengthTypeId: 5403,
    Width1: 233,
    Height1: 111,
    WindowWidth: 233,
    WindowHeight: 111,
    WidthCart: 233,
    HeightCart: 111,
    Lining: "Privacy Lining",
    PanelTypeA: "Pair, Split Draw",
    PanelTypeB: "Pair, Split Draw",
    PanelTypeC: "Pair, Split Draw",
    GrommetFinish: "Satin Brass",
    Hardware: "I Want To Customize Hardware Per Curtain",
    DraperyHardware: "Rod",
    RailDesignA: "9191919101",
    RailDesignFaA: "میله پرده فرانسوی",
    RailDesignEnA: "French Curtain Rod",
    RailIdA: "9191919101",
    RailColorFaA: "برنز",
    RailColorEnA: "Bronze",
    BatonOptionA: "Baton 30cm",
    SheerHardware: "Track",
    RailDesignB: "9199999901",
    RailDesignFaB: "ریل ساده",
    RailDesignEnB: "Standard  Track",
    RailIdB: "9199999901",
    RailColorFaB: "سفید",
    RailColorEnB: "White",
    BatonOptionB: "None",
    PrivacyLayerHardware: "Track",
    RailDesignC: "9199999701",
    RailDesignFaC: "ریل سوپر",
    RailDesignEnC: "Cord Draw Track",
    RailIdC: "9199999702",
    RailColorFaC: "نیکل",
    RailColorEnC: "Satin Nickel",
    ControlPositionC: "Right Control",
    Accessories: [
      {
        SewingAccessoryId: 27,
        SewingModelAccessoryId: 24,
        SewingAccessoryValue: "90908201",
        Qty: 1,
      },
      {
        SewingAccessoryId: 26,
        SewingModelAccessoryId: 23,
        SewingAccessoryValue: "95959502",
        DesignNameEn: "End Cap",
        DesignNameFa: "اند کپ",
        ColorNameEn: "Smoke",
        ColorNameFa: "دودی",
        Qty: 2,
      },
      {
        SewingAccessoryId: 26,
        SewingModelAccessoryId: 23,
        SewingAccessoryValue: "96969601",
        DesignNameEn: "Knob Tiebacks",
        DesignNameFa: "گل میخ",
        ColorNameEn: "Satin Nickel",
        ColorNameFa: "نیکل",
        Qty: 1,
      },
    ],
    RoomNameFa: "اتاق نشیمن",
    RoomNameEn: "Family Room",
    WindowName: "Family Room",
    moreInfoInput: "test notes here for grommet",
    ZipCode: "14537",
    InstallAmount: 10810800,
    TransportationAmount: 4061200,
    SewingOrderDetails: [
      {
        IsLowWrinkle: true,
        IsCoverAll: true,
        IsAltogether: true,
        CurtainPartId: 2303,
        SewingModelId: "0099",
        FabricId: "71008370",
        PanelTypeId: 5903,
        RailId: "9191919101",
        BatonOptionA: "Baton 30cm",
        Accessories: [
          {
            SewingAccessoryId: 27,
            SewingModelAccessoryId: 24,
            SewingAccessoryValue: "90908201",
            Qty: 1,
          },
          {
            SewingAccessoryId: 26,
            SewingModelAccessoryId: 23,
            SewingAccessoryValue: "95959502",
            DesignNameEn: "End Cap",
            DesignNameFa: "اند کپ",
            ColorNameEn: "Smoke",
            ColorNameFa: "دودی",
            Qty: 2,
          },
          {
            SewingAccessoryId: 26,
            SewingModelAccessoryId: 23,
            SewingAccessoryValue: "96969601",
            DesignNameEn: "Knob Tiebacks",
            DesignNameFa: "گل میخ",
            ColorNameEn: "Satin Nickel",
            ColorNameFa: "نیکل",
            Qty: 1,
          },
        ],
        GrommetColorId: 13101,
        LiningTypeId: 6003,
      },
      {
        IsLowWrinkle: true,
        IsCoverAll: true,
        IsAltogether: true,
        CurtainPartId: 2302,
        SewingModelId: "0036",
        FabricId: "90906903",
        PanelTypeId: 5903,
        RailId: "9199999901",
        BatonOptionB: "None",
        Accessories: [],
      },
      {
        IsLowWrinkle: true,
        IsCoverAll: true,
        IsAltogether: true,
        CurtainPartId: 2301,
        SewingModelId: "0002",
        FabricId: "9990909002",
        PanelTypeId: 5903,
        RailId: "9199999702",
        ControlPositionC: "Right Control",
        Accessories: [],
      },
    ],
    ModelNameEn: "Grommet Drapery",
    ModelNameFa: "پرده پانچی",
    NeedInstall: true,
    IsCompleted: true,
    WindowCount: 1,
    Count: 1,
    IsActive: true,
    Price: 198190212,
    WindowDescription: "Test",
    SewingOrderAttachments: [
      {
        FileUrl: "/Content/Images/SewingOrderAttachment/0871f60dc11a4f6496b661f26219ce98.pdf",
        UserFileName: "1405070502.pdf",
      },
    ],
    PreorderText: {
      SewingModelId: "0099",
      FabricId: "71008370",
      FabricDesignFa: "امری",
      FabricDesignEn: "Emery",
      FabricColorEn: "Linen",
      FabricColorFa: "لینن",
      PhotoUrl: "Content/Images/Product/2022/2022-05-09/71008370/71008370_0099.jpg?v=51550",
      FabricId2: "90906903",
      FabricDesignFa2: "تورلینن",
      FabricDesignEn2: "Linen M Sheer",
      FabricColorEn2: "White",
      FabricColorFa2: "سفید",
      PhotoUrl2: "Content/Images/Product/2023/2023-12-26/90906903/90906903_0099.jpg?v=51551",
      SheerHeaderStyle: "Inverted Box Pleat",
      SheerHeaderStyleID: "0036",
      PrivacyLayer: "Semi Sheer",
      SheersId1: "9990909002",
      SheersDesignFa: "سرن",
      SheersDesignEn: "Serene",
      SheersColorEn: "Ice",
      SheersColorFa: "یخی",
      SheersPhotoUrl:
        "Content/Images/Product/2021/2021-10-20/9990909002/9990909002_0099.jpg?v=45206",
      PrivacyLayerHeaderStyle: "Pencil Pleat",
      PrivacyLayerHeaderStyleID: "0002",
      MountPositionId: 4802,
      CalcWindowSize: false,
      FinishedLengthTypeId: 5403,
      Width1: 233,
      Height1: 111,
      WindowWidth: 233,
      WindowHeight: 111,
      WidthCart: 233,
      HeightCart: 111,
      Lining: "Privacy Lining",
      PanelTypeA: "Pair, Split Draw",
      PanelTypeB: "Pair, Split Draw",
      PanelTypeC: "Pair, Split Draw",
      GrommetFinish: "Satin Brass",
      Hardware: "I Want To Customize Hardware Per Curtain",
      DraperyHardware: "Rod",
      RailDesignA: "9191919101",
      RailDesignFaA: "میله پرده فرانسوی",
      RailDesignEnA: "French Curtain Rod",
      RailIdA: "9191919101",
      RailColorFaA: "برنز",
      RailColorEnA: "Bronze",
      BatonOptionA: "Baton 30cm",
      SheerHardware: "Track",
      RailDesignB: "9199999901",
      RailDesignFaB: "ریل ساده",
      RailDesignEnB: "Standard  Track",
      RailIdB: "9199999901",
      RailColorFaB: "سفید",
      RailColorEnB: "White",
      BatonOptionB: "None",
      PrivacyLayerHardware: "Track",
      RailDesignC: "9199999701",
      RailDesignFaC: "ریل سوپر",
      RailDesignEnC: "Cord Draw Track",
      RailIdC: "9199999702",
      RailColorFaC: "نیکل",
      RailColorEnC: "Satin Nickel",
      ControlPositionC: "Right Control",
      Accessories: [
        {
          SewingAccessoryId: 27,
          SewingModelAccessoryId: 24,
          SewingAccessoryValue: "90908201",
          Qty: 1,
        },
        {
          SewingAccessoryId: 26,
          SewingModelAccessoryId: 23,
          SewingAccessoryValue: "95959502",
          DesignNameEn: "End Cap",
          DesignNameFa: "اند کپ",
          ColorNameEn: "Smoke",
          ColorNameFa: "دودی",
          Qty: 2,
        },
        {
          SewingAccessoryId: 26,
          SewingModelAccessoryId: 23,
          SewingAccessoryValue: "96969601",
          DesignNameEn: "Knob Tiebacks",
          DesignNameFa: "گل میخ",
          ColorNameEn: "Satin Nickel",
          ColorNameFa: "نیکل",
          Qty: 1,
        },
      ],
      RoomNameFa: "اتاق نشیمن",
      RoomNameEn: "Family Room",
      WindowName: "Family Room",
      moreInfoInput: "test notes here for grommet",
      ZipCode: "14537",
      InstallAmount: 10810800,
      TransportationAmount: 4061200,
      SewingOrderDetails: [
        {
          IsLowWrinkle: true,
          IsCoverAll: true,
          IsAltogether: true,
          CurtainPartId: 2303,
          SewingModelId: "0099",
          FabricId: "71008370",
          PanelTypeId: 5903,
          RailId: "9191919101",
          BatonOptionA: "Baton 30cm",
          Accessories: [
            {
              SewingAccessoryId: 27,
              SewingModelAccessoryId: 24,
              SewingAccessoryValue: "90908201",
              Qty: 1,
            },
            {
              SewingAccessoryId: 26,
              SewingModelAccessoryId: 23,
              SewingAccessoryValue: "95959502",
              DesignNameEn: "End Cap",
              DesignNameFa: "اند کپ",
              ColorNameEn: "Smoke",
              ColorNameFa: "دودی",
              Qty: 2,
            },
            {
              SewingAccessoryId: 26,
              SewingModelAccessoryId: 23,
              SewingAccessoryValue: "96969601",
              DesignNameEn: "Knob Tiebacks",
              DesignNameFa: "گل میخ",
              ColorNameEn: "Satin Nickel",
              ColorNameFa: "نیکل",
              Qty: 1,
            },
          ],
          GrommetColorId: 13101,
          LiningTypeId: 6003,
        },
        {
          IsLowWrinkle: true,
          IsCoverAll: true,
          IsAltogether: true,
          CurtainPartId: 2302,
          SewingModelId: "0036",
          FabricId: "90906903",
          PanelTypeId: 5903,
          RailId: "9199999901",
          BatonOptionB: "None",
          Accessories: [],
        },
        {
          IsLowWrinkle: true,
          IsCoverAll: true,
          IsAltogether: true,
          CurtainPartId: 2301,
          SewingModelId: "0002",
          FabricId: "9990909002",
          PanelTypeId: 5903,
          RailId: "9199999702",
          ControlPositionC: "Right Control",
          Accessories: [],
        },
      ],
      ModelNameEn: "Grommet Drapery",
      ModelNameFa: "پرده پانچی",
      NeedInstall: true,
      IsCompleted: true,
      WindowCount: 1,
      Count: 1,
      IsActive: true,
      Price: 198190212,
      WindowDescription: "Test",
      SewingOrderAttachments: [
        {
          FileUrl: "/Content/Images/SewingOrderAttachment/0871f60dc11a4f6496b661f26219ce98.pdf",
          UserFileName: "1405070502.pdf",
        },
      ],
    },
  },
  {
    PhotoUrl: "Content/Images/Product/2020/2020-12-13/61541604/61541604_0303.jpg?v=45184",
    PageId: "1",
    SewingModelId: "0303",
    FabricId: "61541604",
    FabricDesignFa: "سیمپل",
    FabricDesignEn: "Simple",
    FabricColorEn: "Dark Beige",
    FabricColorFa: "بژ سیر",
    MountPositionId: 4802,
    IsWalled: false,
    CalcWindowSize: true,
    Width1: 230,
    LeftStackWidth: 11,
    RightStackWidth: 11,
    Height1: 199,
    Height2: 199,
    Height3: 199,
    WindowWidth: 252,
    WindowHeight: 214,
    WidthCart: 249,
    HeightCart: 214,
    hasPower: true,
    ControlType: "Motorized",
    MotorChannels: ["0", "1", "2"],
    MotorType: "Standard",
    MotorPosition: "Left",
    RemoteName: "Test",
    MetalValanceStyle: "Metal Valance",
    MetalValanceColor: "Silver",
    RoomNameFa: "اتاق نشیمن",
    RoomNameEn: "Family Room",
    WindowName: "Family Room",
    ZipCode: "14537",
    Price: 166592000,
    InstallAmount: 3603600,
    TransportationAmount: 4061200,
    SewingOrderDetails: [
      {
        IsLowWrinkle: true,
        IsCoverAll: true,
        IsAltogether: true,
        CurtainPartId: 2303,
        SewingModelId: "0303",
        FabricId: "61541604",
        fabricItemId: 717006536,
      },
    ],
    ModelNameEn: "Zebra Shades",
    ModelNameFa: "پرده زبرا",
    NeedInstall: true,
    IsCompleted: true,
    WindowCount: 1,
    Count: 1,
    IsActive: true,
    WindowDescription: "Cord",
    SewingOrderAttachments: [
      {
        FileUrl: "/Content/Images/SewingOrderAttachment/a27d8a32063547338e3c860846906709.jpg",
        UserFileName: "-2147483648_-210079.jpg",
      },
      {
        FileUrl: "/Content/Images/SewingOrderAttachment/3cfa4f39dbb94d60838332f4bcce9d5b.pdf",
        UserFileName: "1405070502.pdf",
      },
    ],
    installationLocation: "Ceiling",
    fabricItemId: 717006536,
    PreorderText: {
      PhotoUrl: "Content/Images/Product/2020/2020-12-13/61541604/61541604_0303.jpg?v=45184",
      PageId: "1",
      SewingModelId: "0303",
      FabricId: "61541604",
      FabricDesignFa: "سیمپل",
      FabricDesignEn: "Simple",
      FabricColorEn: "Dark Beige",
      FabricColorFa: "بژ سیر",
      MountPositionId: 4802,
      IsWalled: false,
      CalcWindowSize: true,
      Width1: 230,
      LeftStackWidth: 11,
      RightStackWidth: 11,
      Height1: 199,
      Height2: 199,
      Height3: 199,
      WindowWidth: 252,
      WindowHeight: 214,
      WidthCart: 249,
      HeightCart: 214,
      hasPower: true,
      ControlType: "Motorized",
      MotorChannels: ["0", "1", "2"],
      MotorType: "Standard",
      MotorPosition: "Left",
      RemoteName: "Test",
      MetalValanceStyle: "Metal Valance",
      MetalValanceColor: "Silver",
      RoomNameFa: "اتاق نشیمن",
      RoomNameEn: "Family Room",
      WindowName: "Family Room",
      ZipCode: "14537",
      Price: 166592000,
      InstallAmount: 3603600,
      TransportationAmount: 4061200,
      SewingOrderDetails: [
        {
          IsLowWrinkle: true,
          IsCoverAll: true,
          IsAltogether: true,
          CurtainPartId: 2303,
          SewingModelId: "0303",
          FabricId: "61541604",
          fabricItemId: 717006536,
        },
      ],
      ModelNameEn: "Zebra Shades",
      ModelNameFa: "پرده زبرا",
      NeedInstall: true,
      IsCompleted: true,
      WindowCount: 1,
      Count: 1,
      IsActive: true,
      WindowDescription: "Cord",
      SewingOrderAttachments: [
        {
          FileUrl: "/Content/Images/SewingOrderAttachment/a27d8a32063547338e3c860846906709.jpg",
          UserFileName: "-2147483648_-210079.jpg",
        },
        {
          FileUrl: "/Content/Images/SewingOrderAttachment/3cfa4f39dbb94d60838332f4bcce9d5b.pdf",
          UserFileName: "1405070502.pdf",
        },
      ],
      installationLocation: "Ceiling",
      fabricItemId: 717006536,
    },
  },
  {
    PhotoUrl: "Content/Images/Product/2020/2020-12-13/61541604/61541604_0303.jpg?v=45184",
    PageId: "1",
    SewingModelId: "0303",
    FabricId: "61541604",
    FabricDesignFa: "سیمپل",
    FabricDesignEn: "Simple",
    FabricColorEn: "Dark Beige",
    FabricColorFa: "بژ سیر",
    MountPositionId: 4803,
    CalcWindowSize: false,
    WindowWidth: 230,
    WindowHeight: 211,
    ControlType: "Continuous Loop",
    ControlPosition: "Left",
    ChainLength: "250",
    MetalValanceStyle: "Metal Valance",
    MetalValanceColor: "Silver",
    RoomNameFa: "اتاق نشیمن",
    RoomNameEn: "Family Room",
    WindowName: "Family Room",
    Price: 128540000,
    WidthCart: 230,
    HeightCart: 211,
    Width1: 230,
    Height1: 211,
    SewingOrderDetails: [
      {
        IsLowWrinkle: true,
        IsCoverAll: true,
        IsAltogether: true,
        CurtainPartId: 2303,
        SewingModelId: "0303",
        FabricId: "61541604",
        fabricItemId: 6872293,
      },
    ],
    ModelNameEn: "Zebra Shades",
    ModelNameFa: "پرده زبرا",
    NeedInstall: false,
    InstallAmount: 0,
    TransportationAmount: 0,
    IsCompleted: true,
    WindowCount: 1,
    Count: 1,
    IsActive: true,
    WindowDescription: "Cord",
    fabricItemId: 6872293,
    PreorderText: {
      PhotoUrl: "Content/Images/Product/2020/2020-12-13/61541604/61541604_0303.jpg?v=45184",
      PageId: "1",
      SewingModelId: "0303",
      FabricId: "61541604",
      FabricDesignFa: "سیمپل",
      FabricDesignEn: "Simple",
      FabricColorEn: "Dark Beige",
      FabricColorFa: "بژ سیر",
      MountPositionId: 4803,
      CalcWindowSize: false,
      WindowWidth: 230,
      WindowHeight: 211,
      ControlType: "Continuous Loop",
      ControlPosition: "Left",
      ChainLength: "250",
      MetalValanceStyle: "Metal Valance",
      MetalValanceColor: "Silver",
      RoomNameFa: "اتاق نشیمن",
      RoomNameEn: "Family Room",
      WindowName: "Family Room",
      Price: 128540000,
      WidthCart: 230,
      HeightCart: 211,
      Width1: 230,
      Height1: 211,
      SewingOrderDetails: [
        {
          IsLowWrinkle: true,
          IsCoverAll: true,
          IsAltogether: true,
          CurtainPartId: 2303,
          SewingModelId: "0303",
          FabricId: "61541604",
          fabricItemId: 6872293,
        },
      ],
      ModelNameEn: "Zebra Shades",
      ModelNameFa: "پرده زبرا",
      NeedInstall: false,
      InstallAmount: 0,
      TransportationAmount: 0,
      IsCompleted: true,
      WindowCount: 1,
      Count: 1,
      IsActive: true,
      WindowDescription: "Cord",
      fabricItemId: 6872293,
    },
  },
];

export const DEMO_PRODUCTS_SINGLE = [
  {
    PhotoUrl: "Content/Images/Product/2022/2022-05-09/71008374/71008374_0321.jpg?v=37811",
    PageType: "Drapery&Sheers",
    PageId: "183",
    SewingModelId: "0321",
    FabricId: "71008374",
    FabricDesignFa: "امری",
    FabricDesignEn: "Emery",
    FabricColorEn: "gray",
    FabricColorFa: "طوسی",
    FabricId2: "90906801",
    FabricDesignFa2: "تور استیچ",
    FabricDesignEn2: "Sheer ML Stitch",
    FabricColorEn2: "White",
    FabricColorFa2: "سفید",
    PhotoUrl2: "Content/Images/Product/2023/2023-12-26/90906801/90906801_0321.jpg?v=46031",
    SheerHeaderStyle: "Pencil Pleat",
    SheerHeaderStyleID: "0001",
    PrivacyLayer: "Opaque",
    SheersId2: "90909102",
    SheersDesignFa: "بلا",
    SheersDesignEn: "Bella",
    SheersColorEn: "Ice",
    SheersColorFa: "یخی",
    PrivacyLayerHeaderStyle: "Pencil Pleat",
    PrivacyLayerHeaderStyleID: "0002",
    MountPositionId: 4801,
    CalcWindowSize: true,
    RodInstalled: false,
    FinishedLengthTypeId: 5402,
    CurtainPositionId: 4901,
    Width1: 233,
    LeftStackWidth: 10,
    RightStackWidth: 15,
    Height1: 222,
    Height2: 222,
    Height3: 223,
    RoomHeight: 288,
    WindowWidth: 258,
    WindowHeight: 223,
    WidthCart: 233,
    HeightCart: 233,
    Lining: "Privacy Lining",
    PanelCoverage: "Decorative",
    PanelTypeA: "Pair, Split Draw",
    PanelTypeB: "Single Panel",
    PanelTypeC: "Pair, Split Draw",
    Hardware: "I Have My Own Hardware",
    hardwareDrapery: "I Have Standard Track",
    hardwareSheer: "I Have Track With Cord Draw",
    hardwarePrivacyLayer: "I Have Standard Track",
    HandCurtainId: 2401,
    HandCurtainNum: 2,
    HandCurtainEn: "Matching Drapery Tieback",
    HandCurtainFa: "کمرپرده پارچه ای",
    Accessories: [
      {
        SewingAccessoryId: 26,
        SewingModelAccessoryId: 33,
        SewingAccessoryValue: "94949401",
        DesignNameEn: "Classic Tassels",
        DesignNameFa: "کمر پرده",
        ColorNameEn: "Taupe",
        ColorNameFa: "طوسى و قهوه اى",
        Qty: 2,
      },
      {
        SewingAccessoryId: 26,
        SewingModelAccessoryId: 33,
        SewingAccessoryValue: "95959502",
        DesignNameEn: "End Cap",
        DesignNameFa: "اند کپ",
        ColorNameEn: "Smoke",
        ColorNameFa: "دودی",
        Qty: 3,
      },
      {
        SewingAccessoryId: 26,
        SewingModelAccessoryId: 33,
        SewingAccessoryValue: "96969603",
        DesignNameEn: "Knob Tiebacks",
        DesignNameFa: "گل میخ",
        ColorNameEn: "Satin Brass",
        ColorNameFa: "برنجی",
        Qty: 4,
      },
    ],
    RoomNameFa: "اتاق نشیمن",
    RoomNameEn: "Family Room",
    WindowName: "Family Room",
    moreInfoInput: "test pleated",
    ZipCode: "14537",
    InstallAmount: 10810800,
    TransportationAmount: 4061200,
    SewingOrderDetails: [
      {
        IsLowWrinkle: true,
        IsCoverAll: false,
        IsAltogether: true,
        CurtainPartId: 2303,
        SewingModelId: "0321",
        PageType: "Drapery&Sheers",
        FabricId: "71008374",
        PanelTypeId: 5903,
        HandCurtainId: 2401,
        HandCurtainNum: 2,
        Accessories: [
          {
            SewingAccessoryId: 26,
            SewingModelAccessoryId: 33,
            SewingAccessoryValue: "94949401",
            DesignNameEn: "Classic Tassels",
            DesignNameFa: "کمر پرده",
            ColorNameEn: "Taupe",
            ColorNameFa: "طوسى و قهوه اى",
            Qty: 2,
          },
          {
            SewingAccessoryId: 26,
            SewingModelAccessoryId: 33,
            SewingAccessoryValue: "95959502",
            DesignNameEn: "End Cap",
            DesignNameFa: "اند کپ",
            ColorNameEn: "Smoke",
            ColorNameFa: "دودی",
            Qty: 3,
          },
          {
            SewingAccessoryId: 26,
            SewingModelAccessoryId: 33,
            SewingAccessoryValue: "96969603",
            DesignNameEn: "Knob Tiebacks",
            DesignNameFa: "گل میخ",
            ColorNameEn: "Satin Brass",
            ColorNameFa: "برنجی",
            Qty: 4,
          },
        ],
        LiningTypeId: 6003,
      },
      {
        IsLowWrinkle: true,
        IsCoverAll: true,
        IsAltogether: true,
        CurtainPartId: 2302,
        SewingModelId: "0001",
        FabricId: "90906801",
        PanelTypeId: 5901,
        Accessories: [],
      },
      {
        IsLowWrinkle: true,
        IsCoverAll: true,
        IsAltogether: true,
        CurtainPartId: 2301,
        SewingModelId: "0002",
        FabricId: "90909102",
        PanelTypeId: 5903,
        Accessories: [],
      },
    ],
    ModelNameEn: "Double European Pleat Drapery",
    ModelNameFa: "پرده دوچین اروپایی",
    NeedInstall: true,
    IsCompleted: true,
    WindowCount: 1,
    Count: 1,
    IsActive: true,
    Price: 102146555,
    WindowDescription: "Cord",
    SewingOrderAttachments: [
      {
        FileUrl: "/Content/Images/SewingOrderAttachment/b0076d8ba6f94e61b8763684564d3fbc.pdf",
        UserFileName: "1405070502.pdf",
      },
    ],
    PreorderText: {
      PhotoUrl: "Content/Images/Product/2022/2022-05-09/71008374/71008374_0321.jpg?v=37811",
      PageType: "Drapery&Sheers",
      PageId: "183",
      SewingModelId: "0321",
      FabricId: "71008374",
      FabricDesignFa: "امری",
      FabricDesignEn: "Emery",
      FabricColorEn: "gray",
      FabricColorFa: "طوسی",
      FabricId2: "90906801",
      FabricDesignFa2: "تور استیچ",
      FabricDesignEn2: "Sheer ML Stitch",
      FabricColorEn2: "White",
      FabricColorFa2: "سفید",
      PhotoUrl2: "Content/Images/Product/2023/2023-12-26/90906801/90906801_0321.jpg?v=46031",
      SheerHeaderStyle: "Pencil Pleat",
      SheerHeaderStyleID: "0001",
      PrivacyLayer: "Opaque",
      SheersId2: "90909102",
      SheersDesignFa: "بلا",
      SheersDesignEn: "Bella",
      SheersColorEn: "Ice",
      SheersColorFa: "یخی",
      PrivacyLayerHeaderStyle: "Pencil Pleat",
      PrivacyLayerHeaderStyleID: "0002",
      MountPositionId: 4801,
      CalcWindowSize: true,
      RodInstalled: false,
      FinishedLengthTypeId: 5402,
      CurtainPositionId: 4901,
      Width1: 233,
      LeftStackWidth: 10,
      RightStackWidth: 15,
      Height1: 222,
      Height2: 222,
      Height3: 223,
      RoomHeight: 288,
      WindowWidth: 258,
      WindowHeight: 223,
      WidthCart: 233,
      HeightCart: 233,
      Lining: "Privacy Lining",
      PanelCoverage: "Decorative",
      PanelTypeA: "Pair, Split Draw",
      PanelTypeB: "Single Panel",
      PanelTypeC: "Pair, Split Draw",
      Hardware: "I Have My Own Hardware",
      hardwareDrapery: "I Have Standard Track",
      hardwareSheer: "I Have Track With Cord Draw",
      hardwarePrivacyLayer: "I Have Standard Track",
      HandCurtainId: 2401,
      HandCurtainNum: 2,
      HandCurtainEn: "Matching Drapery Tieback",
      HandCurtainFa: "کمرپرده پارچه ای",
      Accessories: [
        {
          SewingAccessoryId: 26,
          SewingModelAccessoryId: 33,
          SewingAccessoryValue: "94949401",
          DesignNameEn: "Classic Tassels",
          DesignNameFa: "کمر پرده",
          ColorNameEn: "Taupe",
          ColorNameFa: "طوسى و قهوه اى",
          Qty: 2,
        },
        {
          SewingAccessoryId: 26,
          SewingModelAccessoryId: 33,
          SewingAccessoryValue: "95959502",
          DesignNameEn: "End Cap",
          DesignNameFa: "اند کپ",
          ColorNameEn: "Smoke",
          ColorNameFa: "دودی",
          Qty: 3,
        },
        {
          SewingAccessoryId: 26,
          SewingModelAccessoryId: 33,
          SewingAccessoryValue: "96969603",
          DesignNameEn: "Knob Tiebacks",
          DesignNameFa: "گل میخ",
          ColorNameEn: "Satin Brass",
          ColorNameFa: "برنجی",
          Qty: 4,
        },
      ],
      RoomNameFa: "اتاق نشیمن",
      RoomNameEn: "Family Room",
      WindowName: "Family Room",
      moreInfoInput: "test pleated",
      ZipCode: "14537",
      InstallAmount: 10810800,
      TransportationAmount: 4061200,
      SewingOrderDetails: [
        {
          IsLowWrinkle: true,
          IsCoverAll: false,
          IsAltogether: true,
          CurtainPartId: 2303,
          SewingModelId: "0321",
          PageType: "Drapery&Sheers",
          FabricId: "71008374",
          PanelTypeId: 5903,
          HandCurtainId: 2401,
          HandCurtainNum: 2,
          Accessories: [
            {
              SewingAccessoryId: 26,
              SewingModelAccessoryId: 33,
              SewingAccessoryValue: "94949401",
              DesignNameEn: "Classic Tassels",
              DesignNameFa: "کمر پرده",
              ColorNameEn: "Taupe",
              ColorNameFa: "طوسى و قهوه اى",
              Qty: 2,
            },
            {
              SewingAccessoryId: 26,
              SewingModelAccessoryId: 33,
              SewingAccessoryValue: "95959502",
              DesignNameEn: "End Cap",
              DesignNameFa: "اند کپ",
              ColorNameEn: "Smoke",
              ColorNameFa: "دودی",
              Qty: 3,
            },
            {
              SewingAccessoryId: 26,
              SewingModelAccessoryId: 33,
              SewingAccessoryValue: "96969603",
              DesignNameEn: "Knob Tiebacks",
              DesignNameFa: "گل میخ",
              ColorNameEn: "Satin Brass",
              ColorNameFa: "برنجی",
              Qty: 4,
            },
          ],
          LiningTypeId: 6003,
        },
        {
          IsLowWrinkle: true,
          IsCoverAll: true,
          IsAltogether: true,
          CurtainPartId: 2302,
          SewingModelId: "0001",
          FabricId: "90906801",
          PanelTypeId: 5901,
          Accessories: [],
        },
        {
          IsLowWrinkle: true,
          IsCoverAll: true,
          IsAltogether: true,
          CurtainPartId: 2301,
          SewingModelId: "0002",
          FabricId: "90909102",
          PanelTypeId: 5903,
          Accessories: [],
        },
      ],
      ModelNameEn: "Double European Pleat Drapery",
      ModelNameFa: "پرده دوچین اروپایی",
      NeedInstall: true,
      IsCompleted: true,
      WindowCount: 1,
      Count: 1,
      IsActive: true,
      Price: 102146555,
      WindowDescription: "Cord",
      SewingOrderAttachments: [
        {
          FileUrl: "/Content/Images/SewingOrderAttachment/b0076d8ba6f94e61b8763684564d3fbc.pdf",
          UserFileName: "1405070502.pdf",
        },
      ],
      MotorPositionA: [],
      MotorChannelsA: ["0"],
    },
    MotorChannelsA: ["0"],
  },
];

export const DEMO_PRODUCTS_READYMADE = [];
